import React from "react";
import styled from "styled-components";

import {
  formatCommercialRuleConfiguration,
  getCommercialRuleTypeLabel,
} from "./commercialRulePresentation";

import { AdminButton } from "../../../pages/admin/action_engine";

import {
  AdminTable,
  AdminTableViewport,
} from "../../../pages/admin/section_engine";
export default function CommercialRulesList({
  rules,
  deletingRuleUuid,
  onEdit,
  onDelete,
}) {
  return (
    <Viewport>
      <Table>
        <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Configuration</th>
            <th scope="col">Priorité</th>
            <th scope="col">Statut</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {rules.map((rule) => {
            const deleting = deletingRuleUuid === rule.uuid;
            return (
              <tr key={rule.uuid}>
                <td>
                  <Identity>
                    <strong>{getCommercialRuleTypeLabel(rule.rule_type)}</strong>
                    <span>{rule.rule_type}</span>
                  </Identity>
                </td>
                <td>
                  <ConfigList>
                    {formatCommercialRuleConfiguration(rule).map((line) => (
                      <li key={line}>{line}</li>
                    ))}
                  </ConfigList>
                </td>
                <td>{rule.priority}</td>
                <td>
                  <Badge $active={rule.active}>
                    {rule.active ? "Actif" : "Inactif"}
                  </Badge>
                </td>
                <td>
                  <Actions>
                    <AdminButton variant="secondary" type="button" disabled={deleting} onClick={() => onEdit(rule)}>
                      Modifier
                    </AdminButton>
                    <AdminButton variant="danger" type="button" disabled={deleting} onClick={() => onDelete(rule)}>
                      {deleting ? "Suppression…" : "Supprimer"}
                    </AdminButton>
                  </Actions>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Viewport>
  );
}

const Viewport = styled(AdminTableViewport)`
  width: 100%;
  overflow-x: auto;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
`;

const Table = styled(AdminTable)`
  width: 100%;
  min-width: 840px;
  border-collapse: collapse;
  background: #202a43;
  th, td {
    padding: 0.85rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    text-align: left;
    vertical-align: top;
  }
  th {
    color: rgba(247, 247, 247, 0.62);
    font-size: 0.76rem;
    font-weight: 850;
    text-transform: uppercase;
  }
  tbody tr:last-child td { border-bottom: 0; }
`;

const Identity = styled.div`
  display: grid;
  gap: 0.25rem;
  span { color: rgba(247, 247, 247, 0.52); font-size: 0.75rem; }
`;

const ConfigList = styled.ul`
  display: grid;
  gap: 0.25rem;
  margin: 0;
  padding-left: 1.1rem;
  color: rgba(247, 247, 247, 0.78);
`;

const Badge = styled.span`
  display: inline-flex;
  padding: 0.3rem 0.55rem;
  border-radius: 999px;
  background: ${({ $active }) => $active ? "rgba(73,184,126,.16)" : "rgba(225,95,95,.16)"};
  color: ${({ $active }) => $active ? "#8ce0b2" : "#ffaaaa"};
  font-size: 0.75rem;
  font-weight: 850;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
